var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAihome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.376,
    height: 62.388,
    viewBox: "0 0 62.376 62.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.484 -3.456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667,31.051H13V64.677a.667.667,0,0,0,.667.667H55.522a.667.667,0,0,0,.667-.667V31.051h8.488a.667.667,0,0,0,.433-1.174L35.105,4.16a.667.667,0,0,0-.867,0L4.233,29.878a.667.667,0,0,0,.433,1.174ZM40.673,64.011H27.464V45.341H40.673Zm-6-58.464,28.2,24.171H55.542a.667.667,0,0,0-.667.667V64.011H42.007V44.674a.667.667,0,0,0-.667-.667H26.8a.667.667,0,0,0-.667.667V64.011h-11.8V30.385a.667.667,0,0,0-.667-.667h-7.2Z",
    transform: "translate(0)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.871,47.36a4.554,4.554,0,0,0-4.207,2.787.613.613,0,0,0-.053.267.667.667,0,0,0,.173.453l3.6,3.867a.667.667,0,0,0,.974,0l3.6-3.867a.667.667,0,0,0,.173-.453h0a.567.567,0,0,0-.053-.26A4.554,4.554,0,0,0,47.871,47.36Zm0,5.941-2.794-3.007a3.241,3.241,0,0,1,5.588,0Z",
    transform: "translate(-13.199 -14.448)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.129,35.66a12.335,12.335,0,0,0-9.582,4.547.667.667,0,0,0,0,.88l2.667,2.9a.058.058,0,0,1,.053.04l.047.053a.213.213,0,0,0,.06,0,.44.44,0,0,0,.127.06h.24a.46.46,0,0,0,.133,0,.767.767,0,0,0,.113-.04l.113-.073h.053c.013,0,0-.04.04-.053l.053-.047a7.121,7.121,0,0,1,11.655,0l.047.033a.407.407,0,0,0,.047.067.36.36,0,0,0,.107.067l.073.047a.667.667,0,0,0,.273.067h0a.667.667,0,0,0,.233-.047h.067l.087-.04a.059.059,0,0,1,.047-.053.16.16,0,0,0,.053-.04l2.667-2.9a.667.667,0,0,0,0-.88,12.336,12.336,0,0,0-9.475-4.587Zm6.408,6.855a8.428,8.428,0,0,0-12.816,0l-1.767-1.9a11.042,11.042,0,0,1,16.35,0Z",
    transform: "translate(-10.457 -10.55)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.14,34.318h0a.606.606,0,0,0,.087.053l.113.067h.247a.46.46,0,0,0,.133,0h.113a.72.72,0,0,0,.12-.073.553.553,0,0,0,.08-.053h0a14.923,14.923,0,0,1,22.484,0h0a.507.507,0,0,0,.127.08l.073.047a.667.667,0,0,0,.253.053h0a.773.773,0,0,0,.247-.047l.073-.047a.58.58,0,0,0,.12-.073h0l2.667-2.881a.667.667,0,0,0,0-.9,20.177,20.177,0,0,0-29.805,0,.667.667,0,0,0,0,.9Zm12.229-8.995a18.877,18.877,0,0,1,13.5,5.668l-1.754,1.894a16.243,16.243,0,0,0-23.484,0l-1.754-1.894a18.877,18.877,0,0,1,13.5-5.668Z",
    transform: "translate(-7.697 -6.654)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAihome);
export default __webpack_public_path__ + "static/media/aihome.fd2025fb.svg";
export { ForwardRef as ReactComponent };